import { render, staticRenderFns } from "./StockPositionBrandTable.vue?vue&type=template&id=62332b99&"
import script from "./StockPositionBrandTable.vue?vue&type=script&lang=js&"
export * from "./StockPositionBrandTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports